<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'professionalsCrud'"
          :crudName="$t('professional.crud.title')"
          :newText="$t('professional.crud.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('profissional.gerenciar')"
          :enableEdit="$hasAbility('profissional.gerenciar')"
          :enableDelete="$hasAbility('profissional.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "professionalsTable",
      showMessageImport: false,
      professionalsCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "cbo_id", "tenancy_id", "status", "actions"],
      tableData: [
        "id",
        "cbo_id",
        "name",
        "requester_id",
        "cns",
        "council_number",
        "council_type",
        "sector",
        "phone",
        "requester_doctor",
        "status",
        "tenancy_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "cbo_id", "tenancy_id", "status"],
        sortable: ["id", "name", "requester_id"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('professional.crud.headings.id'),
          name: this.$t('professional.crud.headings.name'),
          cbo_id: this.$t('professional.crud.headings.cboId'),
          tenancy_id: this.$t('professional.crud.headings.tenancyId'),
          status: this.$t('common.status'),
          actions: this.$t('common.actions'),
        },

        texts: {
          filterBy: this.$t('professional.crud.filterBy'),
          defaultOption: this.$t('common.select'),
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: this.$t('common.active'),
            },
            {
              id: 0,
              text: this.$t('common.inactive'),
            },
          ],
        },
        templates: {
          status: (h, row, index) => {
            return row.status == 1
              ? this.$t('common.active')
              : row.status == 0
              ? this.$t('common.inactive')
              : this.$t('common.inactive');
          },
          cbo_id: (h, row, index) => {
            return row.cbo ? row.cbo.cbo_name : this.$t('professional.crud.noName');
          },
          tenancy_id: (h, row, index) => {
            return row.company ? row.company.name : this.$t('professional.crud.noName');
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["cbo", "company"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "professionals",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-professionals";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            self.$t('professional.messages.successTitle'),
            self.$t('professional.messages.importSuccess'),
            "success"
          );
          self.showMessageImport = true;
          self.$refs.professionalsCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            self.$t('professional.messages.importErrorTitle'),
            self.$t('professional.messages.importError'),
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        cbo_id: "cbo[cbo_name]",
        tenancy_id: "company[name]",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>